import { LocalizationProvider } from 'localize-react';
import React, { useState } from 'react';

import { useQueryTranslations } from '../../queries/translations/hooks/useQueryTranslations';
import { getDefaultLanguage } from '../../utils/utils';

export const LocalizationContext = React.createContext({} as any);

export const Localization: React.FC = ({ children }) => {
  const [currentLocale, setLocale] = useState(getDefaultLanguage());
  const { data, loading } = useQueryTranslations({
    variables: {
      lng: currentLocale,
    },
    fetchPolicy: 'no-cache',
  });

  if (loading) {
    return null;
  }

  return (
    <LocalizationContext.Provider
      value={{
        currentLocale,
        setLocale,
      }}
    >
      <LocalizationProvider
        locale={currentLocale}
        translations={{
          [currentLocale]: data?.translations?.content,
        }}
      >
        {children}
      </LocalizationProvider>
    </LocalizationContext.Provider>
  );
};
